// Generated by purs version 0.15.15
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
var element = /* #__PURE__ */ Halogen_HTML_Elements.elementNS("http://www.w3.org/2000/svg");
var ellipse = function (props) {
    return element("ellipse")(props)([  ]);
};
var foreignObject = /* #__PURE__ */ element("foreignObject");
var g = /* #__PURE__ */ element("g");
var image = function (props) {
    return element("image")(props)([  ]);
};
var line = function (props) {
    return element("line")(props)([  ]);
};
var marker = /* #__PURE__ */ element("marker");
var mask = /* #__PURE__ */ element("mask");
var mpath = function (props) {
    return element("mpath")(props)([  ]);
};
var path = function (props) {
    return element("path")(props)([  ]);
};
var polygon = function (props) {
    return element("polygon")(props)([  ]);
};
var polyline = function (props) {
    return element("polyline")(props)([  ]);
};
var rect = function (props) {
    return element("rect")(props)([  ]);
};
var svg = /* #__PURE__ */ element("svg");
var text = /* #__PURE__ */ element("text");
var title = /* #__PURE__ */ element("title");
var use = function (props) {
    return element("use")(props)([  ]);
};
var defs = /* #__PURE__ */ element("defs");
var circleNode = /* #__PURE__ */ element("circle");
var circle = function (props) {
    return element("circle")(props)([  ]);
};
var animateMotion = /* #__PURE__ */ element("animateMotion");
var animate = function (props) {
    return element("animate")(props)([  ]);
};
export {
    element,
    svg,
    g,
    circle,
    image,
    ellipse,
    rect,
    path,
    line,
    polyline,
    polygon,
    text,
    foreignObject,
    defs,
    mask,
    marker,
    animate,
    animateMotion,
    circleNode,
    mpath,
    title,
    use
};
//# sourceMappingURL=index.js.map
